import { useContext } from 'react';
import { CommentStateContext } from "../context/comment-states.js";
export const useCommentState = () => useContext(CommentStateContext);
//# sourceMappingURL=use-comment-state.js.map